<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    @close="handleClose"
    width="50%"
  >
    <el-form ref="Form" :model="item" :rules="rules">
      <el-row>
        <el-col>评论人：<span v-text="item.createUserName"></span></el-col
      ></el-row>
      <el-row>
        <el-col>
          <el-form-item required>
            <el-input
              v-model="item.commentContent"
              size="small"
              placeholder="请输入评论"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="提交"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import { commentInfo, commentUpdate } from "@/api/comment";

export default {
  name: "curd",

  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      item: {},
      rules: {
        commentContent: [rulesFactory.required("请输入评论内容")]
      }
    };
  },
  methods: {
    closeFrom() {
      this.$refs["Form"].resetFields();
      this.isShow = false;
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["Form"].resetFields();
      this.item = {};
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(uuid) {
      commentInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.item = res.data;
        }
      });
    },
    submitForm() {
      this.$refs["Form"].validate(valid => {
        if (valid) {
          //编辑
          commentUpdate(this.item).then(res => {
            if (!res || res.code != 0) return;
            this.$message.success(res.msg);
            Bus.$emit("reload");
          });
          this.closeFrom();
        }
      });
    }
  },
  created() {
    Bus.$on("updateComment", item => {
      this.info(item.uuid);
      this.showFrom("编辑评论");
    });
  }
};
</script>
